export const lightenedPurple = 'rgba(237, 232, 250, 0.4)';
export const lightBlueGrey = '#F4F7FD';
